<template>
  <hr
    class="divider"
    :style="{
      backgroundColor: color,
    }"
  />
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Divider",
  props: {
    color: {
      type: String,
      default: "#eee",
    },
  },
};
</script>

<style scoped>
.divider {
  width: 100%;
  border: none;
  height: 1px;
}
</style>
